// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"fT-z","smallCardRow":"gT-z","largeCardRow":"hT-z","productSearchRow":"iT-z","curatedRow":"jT-z"};